import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["vevo"];
  static values = { visaRequired: Boolean };

  declare vevoTargets: HTMLDivElement[];
  declare visaRequiredValue: boolean;

  connect(): void {
    this.visaRequiredValue ? this.showVevoUpload() : this.hideVevoUpload();
  }

  showVevoUpload(): void {
    this.vevoTargets.forEach((target) => target.classList.remove("hidden"));
  }

  hideVevoUpload(): void {
    this.vevoTargets.forEach((target) => target.classList.add("hidden"));
  }
}
